import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LocalStorageService } from './local-storage-service.service';
import { CartService } from '../generate-client/api/cart.service';
import { CartDto, StoreGetOneDto } from '../generate-client';

@Injectable({
  providedIn: 'root'
})
export class CartQantityService {
  cartQantity = new Subject<any>();
  quantity: number = 0;

  constructor(
    private _localStorageService: LocalStorageService,
    private _cartService: CartService
  ) { }

  public async updateCartQuantity() {

    let id = parseInt(this._localStorageService.getUserId());

    this._cartService.apiCartGetMyCartGet(id).subscribe((cart: CartDto) => {

      this.quantity = 0

      cart.details.forEach(detail => {
        this.quantity += detail.nmQuantity;
      });

      this.cartQantity.next({
        quantity: this.quantity
      });

      this._localStorageService.setCartNo(cart.guidCart);
      this._localStorageService.setCartData(cart);

      let store: StoreGetOneDto = this._localStorageService.getRestaurantData();

      if (this.quantity <= 0 || (store && store.cdStore != cart.cdStore)) {

        this.quantity = 0;

        this.cartQantity.next({
          quantity: this.quantity
        });

        this._localStorageService.clearCartData();
        this._localStorageService.clearCartNo();
      }
    });
  }
}
